import { IJobApply, JobApply } from './../../../../../../models/jobAplly.model';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import * as XLSX from "xlsx";
import { Location } from '@angular/common';
import Swal from 'sweetalert2';
import { IProduct, Product } from '../../../../../../models/product.model';
import { IService, Service } from '../../../../../../models/service.model';
import { ProductService } from '../../../../../../services/product.service';
import { EncryptionService } from '../../../../../../services/EncryptionService';
import { SharedFonctionsService } from '../../../../../../services/shared-fonctions.service';
import { environment } from '../../../../../../environments/environment';
import { FormBuilder, FormControl } from '@angular/forms';
import { JobApplyService } from '../../../../../../services/job_apply.service';

@Component({
  selector: 'app-applied-user',
  templateUrl: './applied-user.component.html',
  styleUrls: ['./applied-user.component.scss']
})
export class AppliedUserComponent implements OnInit {
  url_photo:any;
  jobApplys: IJobApply[] =[];
  jobApplysTmp: IJobApply[] =[];
  filtred:IProduct[]=[];
  filter = false;
  allProduct:IProduct[]=[];
  pageNumber: number = 1;
  pageSize: number = 10;
  totalItems :any;
  beginDateVal: any = null;
  displayErrorMessage: boolean = false;
  endDateVal: any = null;
  disableEndDate: boolean = true;
  p = 1;
  search: any;

  // @ts-ignore
  public modalRef: BsModalRef;

  jobApplyidshared : any;
  jobApplynameshared : String;
  constructor(private router:Router,private jobApplyService: JobApplyService,private fb: FormBuilder,
              private modalService: BsModalService,private encryptionService: EncryptionService,
              private sharedSevice: SharedFonctionsService, private location: Location) { }

  ngOnInit(): void {
    this.url_photo=environment.url_photo;
    this.jobApplyidshared = this.sharedSevice.jobApplyidshared;
    this.jobApplynameshared = this.sharedSevice.jobApplynameshared;
    // alert(this.jobApplyidshared);
    if(this.jobApplyidshared == undefined || this.jobApplyidshared == null) {
      let shopid = window.localStorage.getItem("khjobApplyid!#");
      let shopname = window.localStorage.getItem("khjobApplyname!#");
      if(shopid != null && shopid != undefined){
        let decr = this.encryptionService.decryptionAES(shopid);
        let decr1 = this.encryptionService.decryptionAES(shopname);
        this.jobApplyidshared = decr;
        this.jobApplynameshared = decr1;
      }
    }
    this.loadAppliedUser();
  }

  dateForm = this.fb.group({
    beginDate: new FormControl(''),
    endDate: new FormControl('')
  })

  loadAppliedUser = () => {
    this.allProduct= [];
    this.filtred = [];
    if(this.jobApplyidshared){
      this.jobApplyService.utilisateurAyantPostuler(this.jobApplyidshared, this.pageNumber-1, this.pageSize).subscribe((data :any)=>{
        this.totalItems = data.totalElements;
        // this.product = listeProductRemoveRedondance;
        this.jobApplys = data.content;
        // this.productTmp = listeProductRemoveRedondance;
        this.jobApplysTmp = data.content;
        //console.log("this.jobApplys");
        //console.log(this.jobApplys);
        //console.log(this.jobApplysTmp);
      })
    }
  };

  raiseTableSize(event: any) {
    this.pageSize = event.target.value;
    this.loadAppliedUser();
  }

  currentSection: string = 'mesProduits';
  toggleSection(section: string) {
    this.currentSection = section;
  }

  detailsProduit(prod:IProduct) {
    // this.modalRef = this.modalService.show(DetailsProduitListComponent,
    //   {
    //     initialState:{prod},
    //     backdrop:false,
    //     ignoreBackdropClick:true
    //   });
    // this.modalRef.content.saveEvent.subscribe((resp:any)=>this.loadProduct())
  }

  searchFilter($event: KeyboardEvent) {
    this.search = this.search.toString().toLowerCase();
    this.jobApplys = this.jobApplysTmp.filter(
      value => value.firstname?.toLowerCase().includes(this.search)
      || value.lastname?.toLowerCase().includes(this.search)
      || value.email?.toLowerCase().includes(this.search)
      || value.jobTitle?.toLowerCase().includes(this.search)
      || value.username?.toLowerCase().includes(this.search)
    )
  }


  sortServiceByDate(services: Service[]): Service[] {
    return services.sort((a, b) => {
      if (a.createdAt && b.createdAt) {
        const dateA = new Date(a.createdAt);
        const dateB = new Date(b.createdAt);
        return dateB.getTime() - dateA.getTime();
      } else {
        return 0;
      }
    });
  }


  boutiquePage()
  {
    this.router.navigate(["/boutique"]).then(() => {
      // window.location.reload();
    });
  }

  detailsService(serv:IService){
    // this.modalRef = this.modalService.show(DetailsServiceComponent,
    //   {
    //     initialState:{serv},
    //     backdrop:false,
    //     ignoreBackdropClick:true
    // });
  }

  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  ascendingOrderByCountryName: boolean = true;
  sortByPostName(){
    this.jobApplys.sort((a, b) => {
      const nameA = a.jobTitle.toLowerCase();
      const nameB = b.jobTitle.toLowerCase();

      if(this.ascendingOrderByCountryName){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderByCountryName = !this.ascendingOrderByCountryName;
  }

  ascendingFirstname: boolean = true;
  sortByFirstname(){
    this.jobApplys.sort((a, b) => {
      const nameA = a.firstname.toLowerCase();
      const nameB = b.firstname.toLowerCase();

      if(this.ascendingFirstname){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingFirstname = !this.ascendingFirstname;
  }

  ascendinUsername: boolean = true;
  sortByUsername() {
    this.jobApplys.sort((a, b) => {
      const nameA = a.username;
      const nameB = b.username;
      if(this.ascendinUsername){
        return nameA.localeCompare(nameA);
      }else{
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendinUsername = !this.ascendinUsername;
  }

  ascendingByCreatedDate: boolean = true;
  sortByCreatedDate() {
    this.jobApplys.sort((a, b) => {
      const dateA = new Date(a.created);
      const dateB = new Date(b.created);
      if(this.ascendingByCreatedDate){
        return dateA.getTime() - dateB.getTime();
      }else{
        return dateB.getTime() - dateA.getTime();
      }
    })
    this.ascendingByCreatedDate = !this.ascendingByCreatedDate;
  }


  ascendingByLastName: boolean = true;
  sortByLastName() {
    this.jobApplys.sort((a, b) => {
      const nameA = a.lastname;
      const nameB = b.lastname;

      if(this.ascendingByLastName){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingByLastName = !this.ascendingByLastName;
  }

  ascendingByEmail: boolean = true;
  sortByEmail() {
    this.jobApplys.sort((a, b) => {
      const nameA = a.email;
      const nameB = b.email;

      if(this.ascendingByLastName){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingByEmail = !this.ascendingByEmail;
  }

  exportPostToExelFile(filename: string) {
    const data = document.getElementById('tab-post');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(data);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, filename);
  }

  goBack(): void {
    this.location.back();
  }

  refresh() {
    this.loadAppliedUser();
    this.dateForm.patchValue({
      beginDate: '',
      endDate: ''
    })
  }

  beginDate: any = "";
  endDate: any = "";
  filterByDate() {
    if(this.dateForm.get('beginDate').value=='' || this.dateForm.get('endDate').value=='') {
      //console.log("Date sélectionnée")
      //console.log('beginDate:', this.beginDate);
      //console.log('endDate:', this.endDate);
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez renseigner la date de début et la date de fin',
        showConfirmButton: false,
        timer: 3500
      });
      return;
    }else{
      this.beginDate = new Date(this.dateForm.get('beginDate').value).toISOString();
      this.endDate = new Date(this.dateForm.get('endDate').value).toISOString();
      this.jobApplyService.getJobAppliesByDate(this.jobApplyidshared, this.beginDate, this.endDate,this.pageNumber - 1, this.pageSize).subscribe(data =>{
        this.jobApplys = data.content;
        this.jobApplysTmp = data.content;
        this.totalItems = data.totalElements;

       // console.log("Liste des produits....");
       // console.log(this.jobApplys)
      });
    }
  }

  getBeginDate(event: any) {
    this.beginDateVal = event.target.value;
    if(this.beginDateVal != null){
      this.disableEndDate = false;
      if(this.beginDateVal > this.endDateVal){
        this.displayErrorMessage = true;
      }else {
        this.displayErrorMessage = false;
      }
    }
  }

  getEndDate(event: any) {
    this.endDateVal = event.target.value;
    //console.log(this.endDateVal);
    if(this.beginDateVal > this.endDateVal){
      this.displayErrorMessage = true;
    }else{
      this.displayErrorMessage = false;
    }
  }

  searchJObApplies($event: KeyboardEvent) {
    this.jobApplys = this.jobApplysTmp.filter(
        value => value.firstname?.toLowerCase().includes(this.search)
        || value.lastname?.toLowerCase().includes(this.search)
        || value.email?.toLowerCase().includes(this.search)
        || value.jobTitle?.toLowerCase().includes(this.search)
        || value.username?.toLowerCase().includes(this.search)
    )
  }
}
